module.exports = __webpack_public_path__ + "img/JETTON.a5344ca2.svg";